<template>
  <div class="minilinechart-page">
    <div :id="minilineid" class="minilinechart-container"></div>
  </div>
</template>

<script>
export default {
  props: {
    minilineid: String,
    chartdata: {
      type: Object
    }
  },
  data(){
    return{

    }
  },
  created() {
    this.$nextTick(() => {
      this.initMiniLineChart(this.chartdata)
    });
  },
  watch: {
    chartdata() {
      this.$nextTick(() => {
        this.initMiniLineChart(this.chartdata)
      });
    },
  },

  methods: {
    initMiniLineChart: function(chartdata){
      if(document.getElementById(this.minilineid) === null) return
      let myLineChart = this.$echarts.init(document.getElementById(this.minilineid))
      let option = {
        grid:{
          left: 0,
          top:5,
          bottom:5,
          right:0
        },
        // visualMap: [{
        //   show: false,
        //   type: 'continuous',
        //   seriesIndex: 0,
        //   min: 1000,
        //   max: 5000
        // }],
        xAxis: {
          show: false,
          type: 'category',
          boundaryGap: false,
          data: chartdata.xdata
        },
        yAxis: {
          show: false,
          type: 'value'
        },
        series: [{
          data: chartdata.ydata,
          type: 'line',
          smooth: true,
          showSymbol: false,
          lineStyle: {
            color: '#E5585E',
            width: 2,
            type: 'solid'
          }
        }]
      }      
      myLineChart.clear()
      myLineChart.setOption(option)
      $(window).resize(function () {
        myLineChart.resize()
      })
    },
  }
}
</script>